/* Maja Warszawa — theme scripts */
(function () {
  'use strict';

  var routes = (window.MajaTheme && window.MajaTheme.routes) || {};
  var strings = (window.MajaTheme && window.MajaTheme.strings) || {};

  /* ---------- helpers ---------- */

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var format = (window.MajaTheme && window.MajaTheme.moneyFormat) || '{{amount}}';
    var value = (cents / 100).toFixed(2);
    return format
      .replace('{{amount}}', value.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' '))
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', value.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100));
  }

  function trapFocus(container) {
    var focusables = $$('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', container);
    if (!focusables.length) return function () {};
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    function onKey(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', onKey);
    first.focus();
    return function () { container.removeEventListener('keydown', onKey); };
  }

  /* ---------- drawers ---------- */

  var openDrawer = null;
  var releaseFocus = null;
  var lastTrigger = null;

  function overlay() { return $('[data-overlay]'); }

  function drawerOpen(id, trigger) {
    var el = document.getElementById(id);
    if (!el) return;
    drawerClose();
    lastTrigger = trigger || null;
    el.hidden = false;
    var ov = overlay();
    if (ov) ov.hidden = false;
    requestAnimationFrame(function () {
      el.classList.add('is-open');
      if (ov) ov.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
    openDrawer = el;
    releaseFocus = trapFocus(el);
  }

  function drawerClose() {
    if (!openDrawer) return;
    var el = openDrawer;
    var ov = overlay();
    el.classList.remove('is-open');
    if (ov) ov.classList.remove('is-open');
    document.body.style.overflow = '';
    if (releaseFocus) releaseFocus();
    if (lastTrigger) lastTrigger.focus();
    window.setTimeout(function () {
      el.hidden = true;
      if (ov) ov.hidden = true;
    }, 220);
    openDrawer = null;
    releaseFocus = null;
    lastTrigger = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      drawerOpen(opener.getAttribute('data-drawer-open'), opener);
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.matches('[data-overlay]')) {
      drawerClose();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') drawerClose();
  });

  /* ---------- expandable regions (accordion, facets) ---------- */

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-toggle]');
    if (!toggle) return;
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    panel.hidden = expanded;
  });

  /* ---------- menu drawer: first tap opens, second tap follows ---------- */

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-menu-link]');
    if (!link) return;
    var panel = document.getElementById(link.getAttribute('aria-controls'));
    if (!panel) return;

    // Already open: let the browser follow the href.
    if (link.getAttribute('aria-expanded') === 'true') return;

    e.preventDefault();
    link.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
  });

  /* ---------- announcement rotator ---------- */

  $$('[data-announce]').forEach(function (bar) {
    var items = $$('.announce__item', bar);
    if (items.length < 2) return;
    var delay = parseInt(bar.getAttribute('data-interval'), 10) || 4;
    var i = 0;
    window.setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, delay * 1000);
  });

  /* ---------- hero slideshow ---------- */

  $$('[data-slideshow]').forEach(function (root) {
    var slides = $$('.hero__slide', root);
    if (slides.length < 2) return;
    var dots = $$('.hero__dot', root);
    var index = 0;
    var timer = null;
    var speed = (parseInt(root.getAttribute('data-speed'), 10) || 7) * 1000;

    function go(next) {
      slides[index].classList.remove('is-active');
      if (dots[index]) dots[index].classList.remove('is-active');
      index = (next + slides.length) % slides.length;
      slides[index].classList.add('is-active');
      if (dots[index]) dots[index].classList.add('is-active');
    }

    function start() {
      if (root.getAttribute('data-autoplay') !== 'true') return;
      stop();
      timer = window.setInterval(function () { go(index + 1); }, speed);
    }
    function stop() { if (timer) window.clearInterval(timer); }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { go(i); start(); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    start();
  });

  /* ---------- tabbed timeline ---------- */

  $$('[data-tabs]').forEach(function (root) {
    var tabs = $$('[role="tab"]', root);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', 'false');
          var p = document.getElementById(t.getAttribute('aria-controls'));
          if (p) p.hidden = true;
        });
        tab.setAttribute('aria-selected', 'true');
        var panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = false;
      });
    });
  });

  /* ---------- quantity steppers ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = $('input', btn.parentElement);
    if (!input) return;
    var step = btn.getAttribute('data-qty') === 'up' ? 1 : -1;
    var min = parseInt(input.min, 10) || 0;
    var value = Math.max(min, (parseInt(input.value, 10) || 0) + step);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- product gallery ---------- */

  $$('[data-gallery]').forEach(function (root) {
    var thumbs = $$('.gallery__thumb', root);
    var main = $('[data-gallery-main]', root);
    if (!main) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
        var img = $('img', main);
        if (img) {
          img.src = thumb.getAttribute('data-src');
          img.srcset = thumb.getAttribute('data-srcset') || '';
          img.alt = thumb.getAttribute('data-alt') || '';
        }
      });
    });

    root.addEventListener('maja:variant', function (e) {
      var mediaId = e.detail && e.detail.featured_media && e.detail.featured_media.id;
      if (!mediaId) return;
      var match = thumbs.filter(function (t) { return t.getAttribute('data-media-id') === String(mediaId); })[0];
      if (match) match.click();
    });
  });

  /* ---------- variant picker ----------
     Scoped to the whole product section, because the picker and the
     buy button are separate blocks and can sit apart from each other. */

  $$('[data-product-root]').forEach(function (root) {
    var dataEl = $('[data-variants]', root);
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = $('[data-variant-id]', root);
    var submit = $('[data-add-button]', root);
    var priceEl = $('[data-price-target]', root);
    var stockEl = $('[data-stock]', root);
    var skuEl = $('[data-sku]', root);
    var saveEl = $('[data-save-badge]', root);

    function current() {
      var selected = $$('input[data-option-index]:checked, select[data-option-index]', root).map(function (el) {
        return el.value;
      });
      return variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      })[0];
    }

    function render() {
      var variant = current();

      if (!variant) {
        if (idInput) idInput.value = '';
        if (submit) { submit.disabled = true; submit.textContent = strings.unavailable; }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? strings.addToCart : strings.soldOut;
      }

      if (priceEl && variant.price != null) {
        var html = '<span class="price__now">' + formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<s class="price__was">' + formatMoney(variant.compare_at_price) + '</s>';
          priceEl.classList.add('price--on-sale');
        } else {
          priceEl.classList.remove('price--on-sale');
        }
        priceEl.innerHTML = html;
      }

      if (skuEl) skuEl.textContent = variant.sku || '';

      if (saveEl) {
        var save = 0;
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          save = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        }
        if (save > 0) {
          saveEl.textContent = (saveEl.getAttribute('data-template') || '').replace('[percent]', save);
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }

      if (stockEl) {
        stockEl.className = 'stock';
        if (!variant.available) {
          stockEl.classList.add('stock--out');
          stockEl.textContent = stockEl.getAttribute('data-out') || '';
        } else if (variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
          stockEl.classList.add('stock--low');
          stockEl.textContent = (stockEl.getAttribute('data-low') || '').replace('{{ count }}', variant.inventory_quantity);
        } else {
          stockEl.classList.add('stock--in');
          stockEl.textContent = stockEl.getAttribute('data-in') || '';
        }
      }

      if (window.history.replaceState && root.hasAttribute('data-update-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      // The gallery is a descendant, so the event has to be aimed at it.
      var galleryEl = $('[data-gallery]', root);
      if (galleryEl) {
        galleryEl.dispatchEvent(new CustomEvent('maja:variant', { detail: variant }));
      }
    }

    root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-index]')) return;
      var group = e.target.closest('.option');
      if (group) {
        var readout = $('[data-option-selected]', group);
        if (readout) readout.textContent = e.target.value;
      }
      render();
    });

    render();
  });

  /* ---------- product recommendations ----------
     Shopify only fills the recommendations object when the section is
     requested through the Section Rendering API, so fetch it here. */

  $$('[data-recommendations]').forEach(function (holder) {
    var url = holder.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) {
          holder.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function () {});
  });

  /* ---------- cart ---------- */

  function refreshCartUI(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    $$('[data-cart-count-title]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
    var drawerBody = $('[data-cart-drawer-body]');
    if (drawerBody) {
      fetch(routes.cart + '?section_id=cart-drawer-content')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('[data-cart-drawer-inner]', doc);
          if (fresh) drawerBody.innerHTML = fresh.innerHTML;
        });
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || window.MajaTheme.cartDrawer !== 'drawer') return;
    e.preventDefault();
    var btn = $('[data-add-button]', form);
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '…'; }

    fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: $('[data-variant-id]', form).value, quantity: parseInt($('[name="quantity"]', form) ? $('[name="quantity"]', form).value : 1, 10) || 1 }]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || strings.cartError);
        return fetch(routes.cart + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        refreshCartUI(cart);
        drawerOpen('CartDrawer', btn);
      })
      .catch(function (err) {
        var errBox = $('[data-form-error]', form);
        if (errBox) { errBox.textContent = err.message; errBox.hidden = false; }
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = original; }
      });
  });

  function changeLine(key, quantity) {
    return fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (!remove) return;
    e.preventDefault();
    changeLine(remove.getAttribute('data-cart-remove'), 0).then(function (cart) {
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
      refreshCartUI(cart);
    });
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    changeLine(input.getAttribute('data-cart-qty'), parseInt(input.value, 10) || 0).then(function (cart) {
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
      refreshCartUI(cart);
    });
  });

  /* ---------- swap a line's variant without leaving the cart ---------- */

  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-line-option]');
    if (!select) return;

    var line = select.closest('[data-line-key]');
    var dataEl = line && $('[data-line-variants]', line);
    if (!line || !dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var chosen = $$('[data-line-option]', line).map(function (s) { return s.value; });
    var match = variants.filter(function (v) {
      return v.options.every(function (opt, i) { return opt === chosen[i]; });
    })[0];

    var key = line.getAttribute('data-line-key');
    var qtyInput = $('[data-cart-qty]', line);
    var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;

    if (!match || !match.available) {
      line.classList.add('cart-line--error');
      window.setTimeout(function () { line.classList.remove('cart-line--error'); }, 2000);
      return;
    }

    line.classList.add('is-busy');

    changeLine(key, 0)
      .then(function () {
        return fetch(routes.cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: match.id, quantity: qty }] })
        }).then(function (r) { return r.json(); });
      })
      .then(function () {
        return fetch(routes.cart + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        refreshCartUI(cart);
      })
      .catch(function () {
        line.classList.remove('is-busy');
      });
  });

  /* ---------- predictive search ---------- */

  $$('[data-predictive-search]').forEach(function (wrapper) {
    var input = $('input[type="search"]', wrapper);
    var results = $('[data-predictive-results]', wrapper);
    if (!input || !results || !routes.predictiveSearch) return;
    var timer;

    input.addEventListener('input', function () {
      window.clearTimeout(timer);
      var term = input.value.trim();
      if (term.length < 2) { results.hidden = true; results.innerHTML = ''; return; }
      timer = window.setTimeout(function () {
        var url = routes.predictiveSearch + '?q=' + encodeURIComponent(term) +
          '&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search';
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = $('[data-predictive-inner]', doc);
            results.innerHTML = inner ? inner.innerHTML : '';
            results.hidden = false;
          });
      }, 250);
    });

    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) results.hidden = true;
    });
  });

  /* ---------- collection sort ---------- */

  $$('[data-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  $$('[data-facet-form]').forEach(function (form) {
    form.addEventListener('change', function () { form.submit(); });
  });
})();
